import { MouseEvent, useRef, useState } from 'react'
import {
  CardMedia,
  Grid,
  Typography,
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
  Chip,
} from '@mui/material'
import FlagIcon from '@mui/icons-material/Flag'
import MoreVertIcon from '@mui/icons-material/MoreVert'

import { SubscriptionBadge } from 'src/components/subscription-badge'
import { EAccountSubscriptionPlans, IGridPopperListItem } from 'src/types'

import { useStyles } from './styles'
import { FONTS } from 'src/constants'
import { MoreOutlinedVertIcon } from 'src/assets/icons'
import { GridPopper } from 'src/components/grid-card/grid-popper.component'
import { StatusBadge } from 'src/components/status-badge'
import { useTranslation } from 'react-i18next'

interface IAccountGridCardProps {
  suspended?: boolean
  image: string
  name: string
  onButtonClick: () => void
  handleSuspension: () => Promise<void>
  withSuspended?: boolean
  subscription: EAccountSubscriptionPlans
  userRoleForAccount: string
  items?: IGridPopperListItem[]
  showStatus?: boolean
  status?: boolean
  ai_generated?: boolean
}

const AccountGridCard = ({
  suspended,
  image,
  name,
  onButtonClick,
  handleSuspension,
  withSuspended,
  subscription,
  userRoleForAccount,
  items,
  showStatus,
  status,
  ai_generated = false,
}: IAccountGridCardProps) => {
  const [t] = useTranslation()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const classes = useStyles()
  const [itemHover, setItemHover] = useState<boolean>()
  const [open, setOpen] = useState(false)

  const handleMoreClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setOpen((prev) => !prev)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const anchorRefDesktop = useRef<HTMLButtonElement>(null)
  const anchorRefMobile = useRef<HTMLButtonElement>(null)
  return (
    <>
      <Grid item>
        <Box
          className={classes.cardWrapper}
          sx={{
            bgcolor: ai_generated ? theme.palette.custom.lightGreen : theme.palette.custom.white,
          }}
          onClick={() => {
            if (!itemHover) {
              return onButtonClick()
            }
          }}
        >
          {items && items.length > 0 && (
            <IconButton
              ref={anchorRefDesktop}
              onClick={handleMoreClick}
              className={classes.imageButton}
            >
              <MoreOutlinedVertIcon />
            </IconButton>
          )}
          {items && items.length > 0 && (
            <IconButton
              ref={anchorRefMobile}
              onClick={handleMoreClick}
              className={classes.moreButton}
            >
              <MoreVertIcon />
            </IconButton>
          )}
          {showStatus && (
            <Box className={classes.statusIcon}>
              <StatusBadge
                label={status ? t('product-public-lable.v') : t('product-not-public-lable.v')}
                status={!!status}
              />
            </Box>
          )}
          {withSuspended && (
            <IconButton
              onMouseOver={() => setItemHover(true)}
              onMouseOut={() => setItemHover(false)}
              onClick={handleSuspension}
              className={`${classes.suspensionButtonDesktop} ${
                suspended ? classes.suspensionButtonActive : classes.suspensionButtonInactive
              }`}
            >
              <FlagIcon />
            </IconButton>
          )}
          <Box className={classes.cardImageWrapper}>
            {withSuspended && isTablet ? (
              <SubscriptionBadge
                origin={{ horizontal: 'right', vertical: 'bottom' }}
                subscription={subscription}
              >
                <CardMedia component="img" className={classes.cardImage} image={image} alt={name} />
              </SubscriptionBadge>
            ) : (
              <CardMedia component="img" className={classes.cardImage} image={image} alt={name} />
            )}
          </Box>
          <div className={classes.cardContent}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              <Typography className={classes.cardName} component="h4">
                {name}
              </Typography>
              {isTablet && showStatus && (
                <Chip
                  sx={{
                    maxWidth: '80px',
                    fontWeight: FONTS.WEIGHTS.light,
                    fontSize: FONTS.SIZES.xs,
                    lineHeight: 1.4,
                    height: 'auto',
                    color: status ? 'green' : '#E57373',
                    borderColor: status ? 'green' : '#E57373',
                  }}
                  label={status ? t('product-public-lable.v') : t('product-not-public-lable.v')}
                  variant="outlined"
                  size="small"
                />
              )}
            </Box>
            <Typography sx={{ color: theme.palette.custom.grey3, fontSize: FONTS.SIZES.xs }}>
              {userRoleForAccount}
            </Typography>

            {/* <div className={classes.buttonsWrapper}>
              <Button
                onClick={onButtonClick}
                disabled={!withSuspended && suspended}
                variant="contained"
                sx={{ minWidth: 76 }}
              >
                <HelperWrapper
                  t={
                    withSuspended
                      ? 'accounts-enter-button-text'
                      : suspended
                      ? 'accounts-suspended-button-text'
                      : 'accounts-enter-button-text'
                  }
                />
              </Button>
              {withSuspended && (
                <Button
                  className={classes.suspensionButtonTablet}
                  size="small"
                  variant="outlined"
                  onClick={handleSuspension}
                >
                  <HelperWrapper
                    t={suspended ? 'accounts-unsuspend-button-text' : 'accounts-suspend-button-text'}
                  />
                </Button>
              )}
            </div> */}
          </div>
        </Box>
      </Grid>
      {items && items.length > 0 && (
        <GridPopper
          items={items}
          handleClose={handleClose}
          open={open}
          anchorRef={isTablet ? anchorRefMobile : anchorRefDesktop}
        />
      )}
    </>
  )
}

export { AccountGridCard }
